import { RequestStatus } from 'typed/api';
import { Action } from 'typed/actions';
import { IReducer } from './';
import { deepAssign, deepClone } from 'typed/utils';
import { INEXPIRABLE_REDUCER_EXPIRATION_DATE } from 'utils/constants';

export default function inexpirableReducers<S>(def: S, ...reducers: IReducer<S, Action>[]): IReducer<S, Action> {
    reducers = reducers.reverse();

    return function inexpirableReducers(state: any = deepClone(def), action: any) {
        let i = reducers.length; // https://jsperf.com/foreach-vs-reduce-vs-for-loop,  https://jsperf.com/fastest-array-loops-in-javascript/32

        while (i--) {
            state = reducers[i](state, action);
        }

        if (action.payload && Object.prototype.hasOwnProperty.call(state, 'Custom') && +state.Custom.expires! < +INEXPIRABLE_REDUCER_EXPIRATION_DATE) {
            state = deepAssign(state, { Custom: { expires: action.payload.status !== RequestStatus.FAILED ? INEXPIRABLE_REDUCER_EXPIRATION_DATE : new Date() } });
        }

        return state;
    };
}
